import { render, staticRenderFns } from "./permission-list.vue?vue&type=template&id=77ab33ba"
import script from "./permission-list.vue?vue&type=script&lang=js"
export * from "./permission-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ab33ba')) {
      api.createRecord('77ab33ba', component.options)
    } else {
      api.reload('77ab33ba', component.options)
    }
    module.hot.accept("./permission-list.vue?vue&type=template&id=77ab33ba", function () {
      api.rerender('77ab33ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/security-group/user-binding/permission-list.vue"
export default component.exports